<template>
    <div :class="classNamesElement">
        <label :for="id">
            <translate>{{ label }}</translate>
        </label>
        <Datepicker v-model="formatDate" :enableTimePicker="false" class="datepicker" @update:modelValue="updateValue"
                    :format="format" :previewFormat="format" locale="de" :disabledWeekDays="disabledWeekDays"
                    :disabledDates="disabledDates" :minDate="minDate" :maxDate="maxDate" :startDate="startDate" hideOffsetDates noToday autoApply>
            <template #trigger>
                <input class="form-input" type="text" :name="id" :id="id" v-model="proxyDate" ref="input"
                       :placeholder="placeholder"
                       :required="required" :autofocus="autofocus" autocomplete="off" :disabled="disabled">
                <svg-vue icon="calendar-31" class="icon"/>

                <svg-vue icon="delete-disabled-cross" class="icon icon--clear" @click="clear" v-if="clearable" />
            </template>
        </Datepicker>
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {computed, ref} from 'vue';
import moment from 'moment';

export default {
    name: 'FormDatepicker',
    components: {
        Datepicker
    },
    props: {
        date: {
            type: [Array, String],
            default: '',
        },
        value: {
            default: null,
        },
        id: {},
        label: {},
        placeholder: {},
        required: {},
        autofocus: {},
        autocomplete: {},
        error: {},
        info: {},
        disabled: {},
        icon: {},
        allowHolidays: null,
        allowWeekends: null,
        minDate: null,
        maxDate: null,
        iconOnly: null,
    },
    emits: ['update:date'],
    computed: {
        proxyDate: {
            get() {
                if (this.date) {
                    return moment(this.date).format('DD.MM.YYYY');
                } else {
                    return '';
                }

            },
            set(val) {
                this.$emit('update:date', val);
            },
        },
        classNamesElement() {
            let classNames = ['form-element', 'form-element--icon'];
            if (this.error) classNames.push('form-element--error');
            if (!this.error && this.date) classNames.push('form-element--valid');
            if (this.date) classNames.push('form-element--filled');
            if (this.iconOnly) classNames.push('form-element--icon-only');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
        clearable() {
            return !this.disabled && this.date;
        },
    },
    methods: {
        updateValue() {
            const sqlDate = this.formatDate.toISOString().slice(0, 19).replace('T', ' ');
            this.$emit('update:date', sqlDate);
        },
        clear() {
            this.$emit('update:date', null);
        }
    },
    data() {
        const disabledWeekDays = this.allowWeekends ? [] : [6, 0];

        const disabledDates = this.allowHolidays ? [] : computed(() => {
            return this.$page.props.holidays.map(date => {
                return new Date(date);
            });
        });

        const formatDate = ref();
        const startDate = this.minDate ? ref(moment(this.minDate)._d) : null;

        const format = (formatDate) => {
            const day = formatDate.getDate() < 10 ? '0' + formatDate.getDate() : formatDate.getDate();
            const month = formatDate.getMonth() + 1;
            const year = formatDate.getFullYear();

            return `${day}.${month}.${year}`;
        };

        return {
            formatDate,
            format,
            disabledWeekDays,
            disabledDates,
            startDate,
        };
    }
};
</script>
